import { render, staticRenderFns } from "./StatusHistoryTable.vue?vue&type=template&id=4f78f603&scoped=true&"
import script from "./StatusHistoryTable.vue?vue&type=script&lang=js&"
export * from "./StatusHistoryTable.vue?vue&type=script&lang=js&"
import style0 from "./StatusHistoryTable.vue?vue&type=style&index=0&id=4f78f603&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f78f603",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VDataTable})
